// extracted by mini-css-extract-plugin
module.exports = {"core":"Avatar-core-XJpxg","medium":"Avatar-medium-1Ttoe","big":"Avatar-big-a8lhc","img":"Avatar-img-2yMDU"};